import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlantillaexcel = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "800px",
	height: "800px",
	viewBox: "0 0 48 48",
	id: "Layer_2",
	"data-name": "Layer 2",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "#7fb02f",
	stroke: "#7fb02f",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_bgCarrier",
			strokeWidth: 0
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "SVGRepo_tracerCarrier",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "SVGRepo_iconCarrier",
			children: [
				/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:#7fb02f;stroke-linecap:round;stroke-linejoin:round;}" }) }),
				/* @__PURE__ */ _jsx("polyline", {
					className: "cls-1",
					points: "11.82 18.5 15.5 24 11.82 29.5"
				}),
				/* @__PURE__ */ _jsx("polyline", {
					className: "cls-1",
					points: "19.18 18.5 15.5 24 19.18 29.5"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M5.5,16V32a2,2,0,0,0,2,2h16a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2H7.5A2,2,0,0,0,5.5,16Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M13.23,14V6.5a2,2,0,0,1,2-2H40.5a2,2,0,0,1,2,2v35a2,2,0,0,1-2,2H15.23a2,2,0,0,1-2-2V34"
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgPlantillaexcel);
export { ForwardRef as ReactComponent };
